import { BoxProps, Flex, Text } from '@chakra-ui/react';
import { FC } from 'react';

import { IPosterDocumentOccurrence } from '@/resources/OmnisearchOccurrence';

interface IOmnisearchOccurrencePreview extends BoxProps {
  context: Array<IPosterDocumentOccurrence>;
}

export const OmnisearchOccurrencePreview: FC<IOmnisearchOccurrencePreview> = ({ context, ...rest }) => {
  const highlightedIndex = context.findIndex((c) => c.highlight);
  const beforeHighlighted = context.slice(0, highlightedIndex - 1).map((c) => `${c.content} `);
  const afterHighlighted = context.slice(highlightedIndex + 1, context.length - 1).map((c) => ` ${c.content}`);

  return (
    <Flex justifyContent="center" overflow="hidden" {...rest}>
      <Text
        as="span"
        w="full"
        sx={{ direction: 'rtl' }}
        textOverflow="ellipsis"
        overflow="hidden"
        whiteSpace="nowrap"
        wordBreak="break-word"
      >
        {beforeHighlighted}
      </Text>
      <Text mx="1" as="span" color="white" bg="violet.500">
        {context[highlightedIndex].content}
      </Text>
      <Text as="span" w="full" noOfLines={1} wordBreak="break-word">
        {afterHighlighted}
      </Text>
    </Flex>
  );
};
